  document.addEventListener('DOMContentLoaded', function () {
    const ingredientItems = document.querySelectorAll('.ingredient-item');

    ingredientItems.forEach((item) => {
      const popup = item.querySelector('.ingredient-popup__content');
      const backdrop = popup.querySelector('.ingredient-popup__content--backdrop');
      const closeButton = popup.querySelector('.ingredient-popup__conten--close span');
      const bodyElement = document.querySelector('body');

      // Open popup when ingredient-item is clicked
      item.addEventListener('click', function (e) {
        console.log('item',item);
        console.log('item',popup);
        bodyElement.classList.add('overflow-hidden');
        e.stopPropagation(); // Prevent bubbling to document
        popup.style.display = 'block';
        document.body.classList.add('no-scroll');
      });

      // Close popup when close button is clicked
      closeButton.addEventListener('click', function (e) {
        bodyElement.classList.remove('overflow-hidden');
        e.stopPropagation();
        popup.style.display = 'none';
        document.body.classList.remove('no-scroll');
      });

      // Close popup when backdrop is clicked
      backdrop.addEventListener('click', function (e) {
        bodyElement.classList.remove('overflow-hidden');
        e.stopPropagation();
        popup.style.display = 'none';
        document.body.classList.remove('no-scroll');
      });

      // Optional: Close popup when clicked anywhere outside
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) {
          popup.style.display = 'none';
          document.body.classList.remove('no-scroll');
        }
      });
    });
  });